import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon
} from 'reactstrap';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2'

import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';

import Select from 'react-select';

import {api, API_URL} from '../../actions/_request';
import TablaBancos from "./tabla_bancos";
import TablaAduanas from "./tabla_aduanas";
import TablaUnidades from "./tabla_unidades";
import TablaFormasPago from "./tabla_formaspago";
import TablaMetedosPago from "./tabla_metodospago";
import TablaCodigosPostales from "./tabla_codigospostales";
import TablaMonedas from "./tabla_monedas";
import TablaPaises from "./tabla_paises";
import TablaImpuestos from "./tabla_impuestos";
import TablaRegimenFiscal from "./tabla_regimenfiscal";
import TablaUsosCfdi from "./tabla_usoscfdi";
import TablaTasasCuotas from "./tabla_tasascuotas";
import TablaRelaciones from "./tabla_relaciones";
import TablaProductosServicios from "./tabla_productosservicios";
import TablaProveedores from "./tabla_proveedores";
import TablaImpuestosSistema from "./tabla_impuestos_sistema";
import TablaLineas from "./tabla_lineas";
import TablaMarcas from "./tabla_marcas";
import TablaEstilos from "./tabla_estilos";
import TablaColoresSabores from "./tabla_coloressabores";
import TablaMedidas from "./tabla_medidas";
import TablaEmbarques from "./tabla_embarques";
import TablaLab from "./tabla_lab";
import TablaTerminosPagos from "./tabla_terminospagos";
import TablaDescuentosF from "./tabla_descuentosf";
import TablaAlmacenes from "./tabla_almacenes";
import TablaItems from "./tabla_items";
import TablaFacturasCompras from "./tabla_facturascompras";
import TablaTipoMovimientos from "./tabla_tipomovimientos";
import TablaItemsAlmacen from "./tabla_items_almacen";
import TablaClientes from "./tabla_clientes";
import TablaUsuarios from "./tabla_usuarios";
import TablaFacturasCliente from "./tabla_facturascliente";
import TablaCategorias from "./tabla_categorias";
import TablaTickets from "./tabla_tickets";
import TablaProductosFactura from "./tabla_productos_factura";
import TablaFacturasCancelacion from "./tabla_facturas_cancelacion";
import TablaCaMovimientosSustituto from "./tabla_ca_clientes_sustituto";


class ModalTablas extends React.Component
{
	constructor(props)
	{
		super(props)

		this.state = {
		
        };

     
        this.seleccion= this.seleccion.bind(this);
	}
    seleccion(objeto){
        this.props.retorno(objeto,this.props.campo);
    }
	render()
	{
		
		return(
            /*charCode   es para poner texto en el boton para cerrar  pero aqui se uso para eliminarlo*/
			<Modal isOpen={this.props.open} toggle={this.props.toggle} charCode="" className="default modal-80 ">				
                <ModalHeader >{this.props.titulo}</ModalHeader>
                <ModalBody> 
                    {parseInt(this.props.catalogo)===0 && <TablaBancos retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===1 && <TablaMetedosPago/> }
                    {parseInt(this.props.catalogo)===2 && <TablaFormasPago/> }
                    {parseInt(this.props.catalogo)===3 && <TablaCodigosPostales/> }
                    {parseInt(this.props.catalogo)===4 && <TablaMonedas/> }
                    {parseInt(this.props.catalogo)===5 && <TablaPaises retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===6 && <TablaImpuestos/> }
                    {parseInt(this.props.catalogo)===7 && <TablaRegimenFiscal retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===8 && <TablaUsosCfdi/> }
                    {parseInt(this.props.catalogo)===9 && <TablaTasasCuotas/> }
                    {parseInt(this.props.catalogo)===10 && <TablaUnidades retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===11 && <TablaRelaciones/> }
                    {parseInt(this.props.catalogo)===12 && <TablaProductosServicios retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===13 && <TablaAduanas/> }
                    {parseInt(this.props.catalogo)===14 && <TablaProveedores agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===15 && <TablaImpuestosSistema agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===16 && <TablaLineas retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===17 && <TablaMarcas  agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===18 && <TablaEstilos  agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===19 && <TablaColoresSabores agregar={this.props.agregar}  retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===20 && <TablaMedidas agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===21 && <TablaEmbarques agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===22 && <TablaLab  agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===23 && <TablaTerminosPagos agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===24 && <TablaDescuentosF agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===25 && <TablaAlmacenes agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===26 && <TablaItems  no_agregar={this.props.no_agregar} agregar={this.props.agregar} retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===27 && <TablaFacturasCompras retorno={this.seleccion} proveedor_id={this.props.proveedor_id} filtro={this.props.filtro}/> }
                    {parseInt(this.props.catalogo)===28 && <TablaTipoMovimientos retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===29 && <TablaItemsAlmacen retorno={this.seleccion} almacen={this.props.almacen}/> }
                    {parseInt(this.props.catalogo)===30 && <TablaClientes retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===31 && <TablaUsuarios retorno={this.seleccion}/> }
                    {parseInt(this.props.catalogo)===32 && <TablaFacturasCliente retorno={this.seleccion} cliente_id={this.props.cliente_id}/> }
                    {parseInt(this.props.catalogo)===33 && <TablaCategorias  agregar={this.props.agregar} retorno={this.seleccion} /> }
                    {parseInt(this.props.catalogo)===34 && <TablaTickets   retorno={this.seleccion} /> }
                    {parseInt(this.props.catalogo)===35 && <TablaProductosFactura   retorno={this.seleccion} factura_id={this.props.factura_id} /> }
                    {parseInt(this.props.catalogo)===36 && <TablaFacturasCancelacion   retorno={this.seleccion} /> }
                    {parseInt(this.props.catalogo)===37 && <TablaCaMovimientosSustituto  tipo_movimiento_id={this.props.tipo_movimiento_id}  retorno={this.seleccion} /> }

                    
                            
                </ModalBody>
               <ModalFooter>
                   
                       
                        <div>                            
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancelar
                            </Button>
                        </div>
                    
                </ModalFooter>               
            </Modal>
		);
	}
}

function mapStateToProps(state, ownProps) {
    return {
        ticket : state.ticket,
    }
};

export default connect(mapStateToProps, actions)(ModalTablas)


// WEBPACK FOOTER //
// ./src/components/catalogos/modal_tablas.js